"use client";

import { c as _c } from "react/compiler-runtime";
import { Linkedin } from "@repo/design-system/components/icons/social";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@repo/design-system/components/ui/drop-down-menu";
import { ChevronDown, Mail, Share2 } from "lucide-react";
import { buttonVariants } from "~/components/ui/button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
export default function ShareDropdownHungary(t0) {
  const $ = _c(20);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job.data.language) {
    t1 = job.data.language.toLowerCase();
    $[0] = job.data.language;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const href = `https://allas.eon.hu/${t1}/job/job?id=${job.data.idClient}`;
  let t2;
  if ($[2] !== job.data.title) {
    t2 = job.data.title.replace("&", "and");
    $[2] = job.data.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cleanTitle = t2;
  let t3;
  if ($[4] !== href) {
    t3 = href.replace("=", "%3D");
    $[4] = href;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cleanHref = t3;
  const t4 = `mailto:?subject=Job "${cleanTitle}" (Job-ID: ${job.data.jobNumber})&body=${cleanHref}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Mail size={18} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t.jobad_share_mail || $[8] !== t4) {
    t6 = {
      platform: "mail",
      href: t4,
      icon: t5,
      text: t.jobad_share_mail
    };
    $[7] = t.jobad_share_mail;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `https://www.linkedin.com/sharing/share-offsite/?url=${cleanHref}`;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Linkedin size={18} />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t.jobad_share_linkedin || $[12] !== t7) {
    t9 = {
      platform: "linkedin",
      href: t7,
      icon: t8,
      text: t.jobad_share_linkedin
    };
    $[11] = t.jobad_share_linkedin;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t9) {
    t10 = [t6, t9];
    $[14] = t6;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const social = t10;
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DropdownMenuTrigger className={buttonVariants({
      variant: "ghost"
    })}><Share2 className="size-6" /><ChevronDown className="transition-all duration-100 group-data-[state=open]:rotate-180" /></DropdownMenuTrigger>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== social) {
    t12 = <DropdownMenu>{t11}<DropdownMenuContent align="end" className="rounded-lg bg-white">{social.map(_temp)}</DropdownMenuContent></DropdownMenu>;
    $[18] = social;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}
function _temp(entry) {
  return <DropdownMenuItem asChild={true} className="px-6 py-2 font-thin text-lg first:rounded-t-lg last:rounded-b-lg focus:bg-secondary focus:text-white" key={entry.href}><CustomLink blank={true} className="flex w-full items-center gap-2" href={entry.href}>{entry.icon}<span className="pt-1">{entry.text}</span></CustomLink></DropdownMenuItem>;
}